import React, { useState } from "react";
import Header from "../../page-blocks/common/header";
import Footer from "../../page-blocks/common/footer";

const jobListings = [
  {
    id: 1,
    title: "AI / Machine Learning Engineer",
    department: "Engineering",
    experience: "2–5 Years",
    type: "On-site / Remote",
    description:
      "Design and develop ML pipelines, LLM integrations, and AI-driven features for client products. Strong Python, TensorFlow/PyTorch knowledge required.",
  },
  {
    id: 2,
    title: "Full Stack Web Developer",
    department: "Engineering",
    experience: "2–4 Years",
    type: "On-site",
    description:
      "Build and maintain scalable web applications using React.js, Node.js, and modern databases. Experience with REST APIs and cloud platforms preferred.",
  },
  {
    id: 3,
    title: "React Native / Flutter Developer",
    department: "Mobile",
    experience: "1–3 Years",
    type: "On-site / Remote",
    description:
      "Develop high-performance cross-platform mobile applications. Proficiency in React Native or Flutter with strong UI/UX sensibility.",
  },
  {
    id: 4,
    title: "Odoo ERP Developer",
    department: "ERP & CRM",
    experience: "2–5 Years",
    type: "On-site",
    description:
      "Customize and extend Odoo modules for enterprise clients. Deep knowledge of Python, Odoo ORM, and XML views required.",
  },
  {
    id: 5,
    title: "UI/UX Designer",
    department: "Design",
    experience: "1–3 Years",
    type: "Remote",
    description:
      "Create stunning, user-centred designs for web and mobile platforms. Proficient in Figma, Adobe XD, and design systems.",
  },
  {
    id: 6,
    title: "Digital Marketing Specialist",
    department: "Marketing",
    experience: "1–2 Years",
    type: "On-site",
    description:
      "Drive client growth through SEO, PPC, social media campaigns, and analytics. Experience with Google Ads and Meta Business Suite required.",
  },
  {
    id: 7,
    title: "Business Development Executive",
    department: "Sales",
    experience: "1–3 Years",
    type: "On-site",
    description:
      "Identify and pursue new business opportunities, manage client relationships, and close deals for IT services and software solutions.",
  },
  {
    id: 8,
    title: "QA Engineer",
    department: "Quality Assurance",
    experience: "1–3 Years",
    type: "On-site / Remote",
    description:
      "Test web and mobile applications manually and via automation. Selenium, Cypress, or Appium experience preferred.",
  },
];

const departments = ["All", ...Array.from(new Set(jobListings.map((j) => j.department)))];

const Careers = () => {
  const [selectedDept, setSelectedDept] = useState("All");
  const [expandedJob, setExpandedJob] = useState(null);

  const filtered =
    selectedDept === "All"
      ? jobListings
      : jobListings.filter((j) => j.department === selectedDept);

  return (
    <>
      <Header />
      <style>{`
        .careers-page {
          background: #0d1117;
          min-height: 100vh;
          padding-top: 80px;
          font-family: 'Inter', 'Segoe UI', sans-serif;
        }
        /* Hero */
        .careers-hero {
          background: linear-gradient(135deg, #0f1e3a 0%, #1a2e50 50%, #0d2040 100%);
          padding: 80px 0 60px;
          text-align: center;
          position: relative;
          overflow: hidden;
        }
        .careers-hero::before {
          content: '';
          position: absolute;
          top: -50%;
          left: -50%;
          width: 200%;
          height: 200%;
          background: radial-gradient(ellipse at center, rgba(0,123,255,0.08) 0%, transparent 65%);
          animation: pulseGlow 6s ease-in-out infinite;
        }
        @keyframes pulseGlow {
          0%, 100% { transform: scale(1); opacity: 0.5; }
          50% { transform: scale(1.1); opacity: 1; }
        }
        .careers-hero-badge {
          display: inline-block;
          background: rgba(0,123,255,0.15);
          border: 1px solid rgba(0,123,255,0.3);
          color: #5ba4ff;
          font-size: 13px;
          font-weight: 600;
          letter-spacing: 2px;
          text-transform: uppercase;
          padding: 6px 18px;
          border-radius: 20px;
          margin-bottom: 20px;
        }
        .careers-hero h1 {
          font-size: 48px;
          font-weight: 800;
          color: #ffffff;
          margin-bottom: 16px;
          line-height: 1.2;
          position: relative;
        }
        .careers-hero h1 span {
          background: linear-gradient(90deg, #007bff, #00c6ff);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        .careers-hero p {
          font-size: 17px;
          color: #8899b8;
          max-width: 700px;
          margin: 0 auto;
          line-height: 1.7;
          position: relative;
        }
        /* Stats bar */
        .careers-stats {
          display: flex;
          justify-content: center;
          gap: 60px;
          padding: 30px 0;
          background: rgba(0,123,255,0.04);
          border-top: 1px solid rgba(255,255,255,0.05);
          border-bottom: 1px solid rgba(255,255,255,0.05);
        }
        .stat-item {
          text-align: center;
        }
        .stat-item .stat-num {
          font-size: 28px;
          font-weight: 800;
          color: #007bff;
          display: block;
        }
        .stat-item .stat-label {
          font-size: 13px;
          color: #6b7fa3;
          text-transform: uppercase;
          letter-spacing: 1px;
        }
        /* Filter */
        .careers-filter-section {
          padding: 40px 0 10px;
        }
        .filter-label {
          font-size: 13px;
          font-weight: 600;
          color: #6b7fa3;
          letter-spacing: 1px;
          text-transform: uppercase;
          margin-bottom: 12px;
        }
        .filter-pills {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
        }
        .filter-pill {
          padding: 8px 20px;
          border-radius: 25px;
          border: 1px solid rgba(255,255,255,0.1);
          background: rgba(255,255,255,0.04);
          color: #8899b8;
          font-size: 13px;
          cursor: pointer;
          transition: all 0.2s ease;
        }
        .filter-pill:hover {
          border-color: #007bff;
          color: #ffffff;
        }
        .filter-pill.active {
          background: #007bff;
          border-color: #007bff;
          color: #ffffff;
          font-weight: 600;
        }
        /* Job listings */
        .jobs-section {
          padding: 30px 0 80px;
        }
        .jobs-count {
          font-size: 14px;
          color: #6b7fa3;
          margin-bottom: 20px;
        }
        .jobs-count span {
          color: #ffffff;
          font-weight: 700;
        }
        .job-card {
          background: rgba(255,255,255,0.03);
          border: 1px solid rgba(255,255,255,0.07);
          border-radius: 12px;
          padding: 24px 28px;
          margin-bottom: 16px;
          cursor: pointer;
          transition: all 0.25s ease;
          position: relative;
          overflow: hidden;
        }
        .job-card::before {
          content: '';
          position: absolute;
          left: 0; top: 0; bottom: 0;
          width: 3px;
          background: transparent;
          transition: background 0.25s ease;
          border-radius: 12px 0 0 12px;
        }
        .job-card:hover, .job-card.expanded {
          background: rgba(0,123,255,0.06);
          border-color: rgba(0,123,255,0.25);
          transform: translateX(4px);
        }
        .job-card:hover::before, .job-card.expanded::before {
          background: #007bff;
        }
        .job-card-top {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 16px;
        }
        .job-title {
          font-size: 18px;
          font-weight: 700;
          color: #ffffff;
          margin: 0 0 8px;
        }
        .job-meta {
          display: flex;
          gap: 16px;
          flex-wrap: wrap;
        }
        .job-meta-item {
          display: flex;
          align-items: center;
          gap: 5px;
          font-size: 13px;
          color: #6b7fa3;
        }
        .job-meta-item svg {
          opacity: 0.7;
        }
        .job-dept-badge {
          display: inline-block;
          background: rgba(0,123,255,0.12);
          border: 1px solid rgba(0,123,255,0.2);
          color: #5ba4ff;
          font-size: 11px;
          font-weight: 600;
          padding: 3px 10px;
          border-radius: 12px;
          letter-spacing: 0.5px;
          margin-bottom: 8px;
        }
        .job-view-btn {
          display: flex;
          align-items: center;
          gap: 6px;
          color: #007bff;
          font-size: 14px;
          font-weight: 600;
          white-space: nowrap;
          background: none;
          border: none;
          cursor: pointer;
          transition: gap 0.2s ease;
          padding: 0;
        }
        .job-view-btn:hover {
          gap: 10px;
        }
        .job-description {
          margin-top: 18px;
          padding-top: 18px;
          border-top: 1px solid rgba(255,255,255,0.06);
          animation: fadeSlide 0.25s ease;
        }
        @keyframes fadeSlide {
          from { opacity: 0; transform: translateY(-8px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .job-description p {
          color: #8899b8;
          font-size: 14px;
          line-height: 1.7;
          margin-bottom: 18px;
        }
        .apply-btn {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          background: linear-gradient(135deg, #007bff, #0056cc);
          color: #ffffff;
          font-size: 14px;
          font-weight: 600;
          padding: 10px 24px;
          border-radius: 8px;
          border: none;
          cursor: pointer;
          text-decoration: none;
          transition: all 0.2s ease;
          box-shadow: 0 4px 15px rgba(0,123,255,0.3);
        }
        .apply-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(0,123,255,0.45);
          color: #ffffff;
        }
        /* CTA banner */
        .careers-cta {
          background: linear-gradient(135deg, rgba(0,123,255,0.1), rgba(0,198,255,0.05));
          border: 1px solid rgba(0,123,255,0.2);
          border-radius: 16px;
          padding: 50px 40px;
          text-align: center;
          margin: 20px 0 60px;
        }
        .careers-cta h3 {
          font-size: 26px;
          font-weight: 700;
          color: #ffffff;
          margin-bottom: 10px;
        }
        .careers-cta p {
          color: #8899b8;
          margin-bottom: 24px;
          font-size: 15px;
        }
        @media (max-width: 768px) {
          .careers-hero h1 { font-size: 32px; }
          .careers-stats { gap: 30px; flex-wrap: wrap; padding: 20px; }
          .job-card-top { flex-direction: column; align-items: flex-start; }
          .careers-cta { padding: 30px 20px; }
        }
      `}</style>

      <body>
        <div className="careers-page">
        {/* Hero */}
        <div className="careers-hero">
          <div className="container">
            <div className="careers-hero-badge">We're Hiring</div>
            <h1>Build the Future <span>With Us</span></h1>
            <p>
              Join Microvision Infotech and work on cutting-edge AI, web, and mobile
              solutions that impact businesses worldwide. We value talent, creativity,
              and passion.
            </p>
          </div>
        </div>

        {/* Stats */}
        <div className="careers-stats">
          <div className="stat-item">
            <span className="stat-num">8+</span>
            <span className="stat-label">Open Positions</span>
          </div>
          <div className="stat-item">
            <span className="stat-num">5+</span>
            <span className="stat-label">Departments</span>
          </div>
          <div className="stat-item">
            <span className="stat-num">Remote</span>
            <span className="stat-label">Friendly</span>
          </div>
          <div className="stat-item">
            <span className="stat-num">Growth</span>
            <span className="stat-label">Oriented</span>
          </div>
        </div>

        <div className="container">
          {/* Filter */}
          <div className="careers-filter-section">
            <div className="filter-label">Filter by Department</div>
            <div className="filter-pills">
              {departments.map((dept) => (
                <button
                  key={dept}
                  className={`filter-pill ${selectedDept === dept ? "active" : ""}`}
                  onClick={() => setSelectedDept(dept)}
                >
                  {dept}
                </button>
              ))}
            </div>
          </div>

          {/* Jobs */}
          <div className="jobs-section">
            <div className="jobs-count">
              Showing <span>{filtered.length}</span> open position{filtered.length !== 1 ? "s" : ""}
              {selectedDept !== "All" && <> in <span>{selectedDept}</span></>}
            </div>

            {filtered.map((job) => (
              <div
                key={job.id}
                className={`job-card ${expandedJob === job.id ? "expanded" : ""}`}
                onClick={() => setExpandedJob(expandedJob === job.id ? null : job.id)}
              >
                <div className="job-card-top">
                  <div>
                    <div className="job-dept-badge">{job.department}</div>
                    <h3 className="job-title">{job.title}</h3>
                    <div className="job-meta">
                      <span className="job-meta-item">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
                        </svg>
                        {job.experience}
                      </span>
                      <span className="job-meta-item">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/>
                        </svg>
                        {job.type}
                      </span>
                    </div>
                  </div>
                  <button className="job-view-btn">
                    {expandedJob === job.id ? "Close" : "View Role"}
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                      <line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/>
                    </svg>
                  </button>
                </div>

                {expandedJob === job.id && (
                  <div className="job-description">
                    <p>{job.description}</p>
                    <a
                      href={`mailto:contact@microvisioninfotech.com?subject=Application for ${job.title}`}
                      className="apply-btn"
                      onClick={(e) => e.stopPropagation()}
                    >
                      Apply Now
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                        <line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/>
                      </svg>
                    </a>
                  </div>
                )}
              </div>
            ))}

            {/* CTA for open applications */}
            <div className="careers-cta">
              <h3>Don't see a perfect fit?</h3>
              <p>
                We're always on the lookout for exceptional talent. Send us your CV and
                we'll reach out when the right opportunity arises.
              </p>
              <a
                href="mailto:contact@microvisioninfotech.com?subject=Open Application"
                className="apply-btn"
              >
                Send Open Application
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                  <line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
        </div>

        <Footer />
      </body>
    </>
  );
};

export default Careers;
